import Logo from "assets/logo/logo.png";
import IconDownload from "assets/common/company/icon_download.png";
import CI1 from "assets/common/company/ci1.png";
import CI2 from "assets/common/company/ci2.png";
import CI3 from "assets/common/company/ci3.png";

const CI = () => {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">CI소개</p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%]">
                <p className="text-[#333] text-[25px] text-center">CI (Corporate Identity)</p>
                <div className="border w-full flex flex-col items-center justify-center mt-7 mb-14">
                    <div className="relative py-12 bg-white w-full">
                        <div className="absolute inset-0 w-full bg-[linear-gradient(to_right,#ddd_1px,transparent_1px),linear-gradient(to_bottom,#ddd_1px,transparent_1px)] bg-[size:10px_10px] opacity-30 pointer-events-none"></div>
                        <img src={Logo} alt="Logo" className="relative mx-auto z-10 animate-fade-in" />
                    </div>
                    <div className="border-t py-6 flex items-center bg-[#f8f8f8] w-full px-12 responsive1200:flex-col responsive1200:px-0">
                        <div className="flex flex-col responsive1200:text-center responsive1200:px-[4%]">
                            <p className="text-[17px] text-[#1b2743] font-[500]">밤새워</p>
                            <p className="pt-2.5 pb-[15px] text-[15px] text-[#666]">
                                기도하는 사업, 사랑하는 기업, 연구하는 기업, 봉사하는 기업, 전진과 번영하는 기업
                            </p>
                            <div className="flex gap-[10px] responsive1200:justify-center responsive360:flex-col responsive360:items-center">
                                <a
                                    href="/LOGO.jpg"
                                    download="LOGO.jpg"
                                    className="bg-[#0e0057] text-white px-5 justify-between py-2 flex rounded-[5px] w-[148px] items-center"
                                >
                                    <p>JPG 다운로드</p>
                                    <img src={IconDownload} alt="IconDownload" />
                                </a>

                                <a
                                    href="/LOGO.ai"
                                    download="LOGO.ai"
                                    className="bg-[#0e0057] text-white px-5 justify-between py-2 flex rounded-[5px] w-[134px] items-center"
                                >
                                    <p>AI 다운로드</p>
                                    <img src={IconDownload} alt="IconDownload" />
                                </a>
                            </div>
                        </div>
                        <div className="w-[1px] h-24 mx-[60px] bg-[#333] opacity-20 responsive1200:w-full responsive1200:h-[1px] responsive1200:mx-0 responsive1200:my-[20px]" />
                        <div className="flex flex-col gap-3 items-center justify-center responsive1200:px-[4%] responsive1200:w-full">
                            <p className="text-[25px] font-[600] text-[#1b2743]">OSC</p>
                            <div className="flex items-center relative text-[17px] text-white responsive1200:max-w-[415px] responsive1200:w-full  responsive1200:text-[15px]">
                                <div className="w-[140px] bg-[#0e0057] py-[9px] opacity-70 rounded-full text-center relative responsive1200:flex-1 responsive1200:w-full">
                                    Overnight
                                </div>
                                <div className="w-[140px] bg-[#0e0057] py-[9px] opacity-50 rounded-full text-center relative -ml-5 responsive1200:flex-1 responsive1200:w-full">
                                    Service
                                </div>
                                <div className="w-[140px] bg-[#0e0057] py-[9px] opacity-30 rounded-full text-center relative -ml-5 responsive1200:flex-1 responsive1200:w-full">
                                    Company
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-9">
                    <div className="flex flex-col">
                        <div className="flex text-[#1b2743] text-[18px] pb-2 font-[600] items-center gap-2">
                            <div className="w-2 h-2 border-2 border-[#1b2743] rounded-full" />
                            <p>심볼마크의 의미</p>
                        </div>
                        <p className="text-[#666] pl-4 break-keep">
                            타원의 지구를 뜻하며 타원의 좌, 우측 넓은면은 세계와 우주공간으로의 전진과 반영하겠다는 기업의 의지를 나타내고
                            있습니다.
                        </p>
                    </div>
                    <div className="flex flex-col">
                        <div className="flex text-[#1b2743] text-[18px] pb-2 font-[600] items-center gap-2">
                            <div className="w-2 h-2 border-2 border-[#1b2743] rounded-full" />
                            <p>심볼컬러의 의미</p>
                        </div>
                        <p className="text-[#666] pl-4 break-keep">심볼마크의 청색은 항상 성장(푸르름과 젊음)하는 기업을 의미합니다.</p>
                    </div>
                </div>
                <hr className="my-16 responsive1200:my-[30px]" />
                <div className="flex flex-col items-center">
                    <p className="text-[25px] text-[#333] font-[600] mb-8">사훈</p>
                    <div className="flex items-center gap-10 relative responsive1200:flex-col responsive1200:gap-[120px]">
                        <div className="flex flex-col items-center relative">
                            <div className="border-[11px] border-[#eee] rounded-full w-[200px] h-[200px] flex flex-col items-center pt-[60px]">
                                <img src={CI1} alt="ci1" className="animate-fade-in" />
                                <p className="mt-7 text-[#333] text-[18px]">사랑</p>
                            </div>
                            <p className="text-[#666] mt-7 rounded-full text-[15px] bg-[#eee] w-[280px] h-10 flex items-center justify-center">
                                모든 것을 사랑하고 누구나 사랑하는 기업
                            </p>
                            <div className="hidden responsive1200:block absolute bottom-0 left-1/2 translate-y-full h-[120px] w-[1px] border-2 border-dashed ">
                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-3 h-3 border-[3px] border-[#1b2743] rounded-full bg-white" />
                            </div>
                        </div>
                        <div className="absolute top-24 left-60 w-[120px] h-0 border-t-2 border-dashed responsive1200:hidden" />
                        <div className="absolute top-[91px] left-[295px] w-3 h-3 border-[3px] border-[#1b2743] rounded-full bg-white responsive1200:hidden" />

                        <div className="flex flex-col items-center relative">
                            <div className="border-[11px] border-[#eee] rounded-full w-[200px] h-[200px] flex flex-col items-center pt-[60px]">
                                <img src={CI2} alt="ci2" className="animate-fade-in" />
                                <p className="mt-7 text-[#333] text-[18px]">창조</p>
                            </div>
                            <p className="text-[#666] mt-7 rounded-full text-[15px] bg-[#eee] w-[280px] h-10 flex items-center justify-center">
                                항상 배우고 새로운 것을 만들어가는 기업
                            </p>
                            <div className="hidden responsive1200:block absolute bottom-0 left-1/2 translate-y-full h-[120px] w-[1px] border-2 border-dashed ">
                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-3 h-3 border-[3px] border-[#1b2743] rounded-full bg-white" />
                            </div>
                        </div>

                        <div className="absolute top-24 left-[560px] w-[120px] h-0 border-t-2 border-dashed  responsive1200:hidden" />
                        <div className="absolute top-[91px] left-[613px] w-3 h-3 border-[3px] border-[#1b2743] rounded-full bg-white responsive1200:hidden" />

                        <div className="flex flex-col items-center">
                            <div className="border-[11px] border-[#eee] rounded-full w-[200px] h-[200px] flex flex-col items-center pt-[55px]">
                                <img src={CI3} alt="ci3" className="animate-fade-in" />
                                <p className="mt-6 text-[#333] text-[18px]">신의</p>
                            </div>
                            <p className="text-[#666] mt-7 rounded-full text-[15px] bg-[#eee] w-[280px] h-10 flex items-center justify-center">
                                우리의 가족 / 우리의 상품 / 우리를 믿는 기업
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CI;
